export enum VesselIconZoomMinimumLevels {
    REAL_LIFE = 14,
    NORMAL = 5,
    Dot = 0
}

export enum VesselIconType {
    Normal = 1,
    RealLifeSize = 2,
    Dot = 3,
    MissingHeading = 4
}